export const WORKFLOW_SCHEDULE_EXECUTION_STATE = {
  POLLED: "POLLED",
  FAILED: "FAILED",
  EXECUTED: "EXECUTED",
};
